import actionCreator from '../../../utils/actionCreator';

const communicationsActionTypes = [
  'GET_TOKEN_COMMUNICATIONS',
];

export const { types: communicationsTypes, actions: communicationsActions } = actionCreator(communicationsActionTypes);
